import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

/**
 * Which product an order came from. Orders placed in OneCafe are settled at the
 * counter, so the cashier needs to tell them apart at a glance.
 */
export function SourceBadge({ source }: { source?: string }) {
  const { t } = useTranslation();
  if (!source) return null;

  return (
    <Badge variant={source === 'onecafe' ? 'wine' : 'muted'}>
      {t(`orders.source.${source}`, source)}
    </Badge>
  );
}

/** Whether the money has arrived. Only OneCafe orders are settled at the
 *  counter; a Hoopla one is already paid before the cashier sees it. */
export function PaymentBadge({ isPaid, source }: { isPaid?: boolean; source?: string }) {
  const { t } = useTranslation();
  if (isPaid === undefined || source !== 'onecafe') return null;

  return (
    <Badge variant={isPaid ? 'successSoft' : 'warningSoft'}>
      {t(isPaid ? 'orders.payment.paid' : 'orders.payment.unpaid')}
    </Badge>
  );
}
